import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import useDebounce from '../../hooks/useDebounce';
import {initialize, changeField, readDatabaseList, connectOriginalDB} from '../../modules/admin/database';

import Database from '../../components/admin/database/read/Database';

export default function DatabaseContainer() {
    const dispatch = useDispatch();

    const { aliasName, dbType, viewType, page, pagination, listResponse, listError, connectOriginalResponse, connectOriginalError, changeResponse, changeError, listLoading, connectOriginalLoading } = useSelector(({ database, loading }) => ({
        aliasName: database.aliasName,
        dbType: database.dbType,
        viewType: database.viewType,
        page: database.page,
        pagination: database.pagination,
        listResponse: database.listResponse,
        listError: database.listError,
        connectOriginalResponse: database.connectOriginalResponse,
        connectOriginalError: database.connectOriginalError,
        changeResponse: database.changeResponse,
        changeError: database.changeError,
        listLoading: loading['database/READ_DATABASE_LIST'],
        connectOriginalLoading: loading['database/CONNECT_ORIGINAL_DB']
    }));

    const debouncedAliasName = useDebounce(aliasName, 1000);

    const handleChange = (e) => {    
        const { name, value } = e.target;
        dispatch(changeField({ name, value }));
    };

    const handleConnectOriginalDB = (id) => {
        dispatch(connectOriginalDB({ id }));
    };

    const loadDatabaseLsit = () => {
        dispatch(readDatabaseList({
            aliasName: debouncedAliasName ? debouncedAliasName.trim() : null,
            dbType,
            viewType,
            page
        }));
    };

    useEffect(() => {
        dispatch(initialize());
    }, []);

    useEffect(() => {
        loadDatabaseLsit();
    }, [debouncedAliasName, dbType, viewType, page]);

    // changeOrder 성공 시 리스트 다시 불러오기
    useEffect(() => {
        if (changeResponse) {
            console.log('changeOrder 성공, 리스트 다시 불러오기');
            loadDatabaseLsit();
        }
    }, [changeResponse]);

    // changeOrder 실패 시 처리 (TableList에서 이미 처리하므로 여기서는 로그만)
    useEffect(() => {
        if (changeError) {
            console.log('changeOrder 실패:', changeError);
        }
    }, [changeError]);

    return (
        <Database
            aliasName={aliasName}
            dbType={dbType}
            viewType={viewType}
            pagination={pagination}
            listResponse={listResponse}
            listError={listError}
            connectOriginalResponse={connectOriginalResponse}
            connectOriginalError={connectOriginalError}
            listLoading={listLoading}
            connectOriginalLoading={connectOriginalLoading}
            handleChange={handleChange}
            handleReload={loadDatabaseLsit}
            handleConnectOriginalDB={handleConnectOriginalDB}
        />
    );
}
